import { useTranslation } from 'react-i18next';

export const InternationalTravelBenefits = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'travelph',
  });

  return {
    title: t('title'),
    coverages: [
      {
        label: t('cancellation.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 20,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 25,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 50,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('curtailment.label'),

        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 20,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 25,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 50,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('postponement.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 20,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 25,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 50,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('replacement.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '-',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 2,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('delay.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 10,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 15,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('misconnection.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 10,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 15,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('personal.label'),
        baggageCoverage: {
          parentCoverage: {
            label: t('personal.label'),
            insuredAmountData: [
              {
                classId: 1,
                amount: '',
                remark: null,
                colspan: 1,
              },
              {
                classId: 2,
                amount: '',
                remark: null,
                colspan: 1,
              },
              {
                classId: 3,
                amount: '',
                remark: null,
                colspan: 1,
              },
            ],
          },
          childrenCoverage: [
            {
              label: t('personal.individual'),
              insuredAmountData: [
                {
                  classId: 1,
                  amount: t('amount.item', { amount: ' ₱ 2,500' }),
                  remark: t('remark', { amount: '₱ 20,000' }),
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: t('amount.item', { amount: ' ₱ 2,500' }),
                  remark: t('remark', { amount: '₱ 30,000' }),
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: t('amount.item', { amount: ' ₱ 2,500' }),
                  remark: t('remark', { amount: '₱ 50,000' }),
                  colspan: 1,
                },
              ],
            },
            {
              label: t('personal.family'),
              insuredAmountData: [
                {
                  classId: 1,
                  amount: t('amount.item', { amount: ' ₱ 2,500' }),
                  remark: t('remark', { amount: '₱ 50,000' }),
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: t('amount.item', { amount: ' ₱ 2,500' }),
                  remark: t('remark', { amount: '₱ 60,000' }),
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: t('amount.item', { amount: ' ₱ 2,500' }),
                  remark: t('remark', { amount: '₱ 100,000' }),
                  colspan: 1,
                },
              ],
            },
          ],
        },
      },
      {
        label: t('jewelry.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amount.item', { amount: '₱ 1,000' }),
            remark: t('remark', { amount: '₱ 5,000' }),
            colspan: 1,
          },
          {
            classId: 2,
            amount: t('amount.item', { amount: '₱ 1,000' }),
            remark: t('remark', { amount: '₱ 10,000' }),
            colspan: 1,
          },
          {
            classId: 3,
            amount: t('amount.day', { amount: '₱ 1,000' }),
            remark: t('remark', { amount: '₱ 20,000' }),
            colspan: 1,
          },
        ],
      },
      {
        label: t('baggage.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 15,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 25,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('lossTravelDoc.label'),
        remarks: [t('lossTravelDoc.limit')],
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: '₱ 1,000',
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 15,000',
            remark: '₱ 1,500',
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 25,000',
            remark: '₱ 2,500',
            colspan: 1,
          },
        ],
      },
      {
        label: t('creditCard.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 75,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 125,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('hijack.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('kidnap.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '-',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 10,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('home.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 10,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 20,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('rental.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 15,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 3,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 6,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('petCare.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: t('amount.day', { amount: 'N/A' }),
            remark: t('remark', { amount: 'N/A' }),
            colspan: 1,
          },
          {
            classId: 2,
            amount: t('amount.day', { amount: '₱ 1,000' }),
            remark: t('remark', { amount: '₱ 3,000' }),
            colspan: 1,
          },
          {
            classId: 3,
            amount: t('amount.day', { amount: '₱ 1,000' }),
            remark: t('remark', { amount: '₱ 7,000' }),
            colspan: 1,
          },
        ],
      },
      {
        label: t('golf.label'),
        baggageCoverage: {
          parentCoverage: {
            label: t('golf.label'),
            insuredAmountData: [
              {
                classId: 1,
                amount: '',
                remark: null,
                colspan: 1,
              },
              {
                classId: 2,
                amount: '',
                remark: null,
                colspan: 1,
              },
              {
                classId: 3,
                amount: '',
                remark: null,
                colspan: 1,
              },
            ],
          },
          childrenCoverage: [
            {
              label: t('golf.holdInOne'),
              insuredAmountData: [
                {
                  classId: 1,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: '₱ 2,000',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: '₱ 5,000',
                  remark: null,
                  colspan: 1,
                },
              ],
            },
            {
              label: t('golf.equipment'),
              insuredAmountData: [
                {
                  classId: 1,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: '₱ 2,000',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: '₱ 5,000',
                  remark: null,
                  colspan: 1,
                },
              ],
            },
            {
              label: t('golf.unused'),
              insuredAmountData: [
                {
                  classId: 1,
                  amount: '-',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 2,
                  amount: '₱ 2,000',
                  remark: null,
                  colspan: 1,
                },
                {
                  classId: 3,
                  amount: '₱ 5,000',
                  remark: null,
                  colspan: 1,
                },
              ],
            },
          ],
        },
      },
      {
        label: t('flyer.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '-',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 2,000',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('sports.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 2,500',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 2,500',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
      {
        label: t('deposit.label'),
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 1,500',
            remark: null,
            colspan: 1,
          },
          {
            classId: 2,
            amount: '₱ 2,500',
            remark: null,
            colspan: 1,
          },
          {
            classId: 3,
            amount: '₱ 5,000',
            remark: null,
            colspan: 1,
          },
        ],
      },
    ],
  };
};

export default InternationalTravelBenefits;
